import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from '@mui/material';
import { VideoOrientation } from '../../../common/model/type/video-file.types';
import {
  stagedFieldId,
  stagedFieldsId,
} from '../../../common/utils/video-staging-utils';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvVideoOrientationFieldProps {
  itemKey: string;
  orientation: VideoOrientation | null;
  isDisabled: boolean;
  onChange: (key: string, orientation: VideoOrientation) => void;
}

const OvVideoOrientationField: FC<OvVideoOrientationFieldProps> = ({
  itemKey,
  orientation,
  isDisabled,
  onChange,
}) => {
  const { t } = useTranslation();
  const labelId = `${stagedFieldsId(itemKey)}-orientation-label`;

  return (
    <Field>
      <Question id={labelId}>{t('videos.staging.askOrientation')}</Question>
      <RadioGroup
        row
        aria-labelledby={labelId}
        value={orientation ?? ''}
        onChange={(event) =>
          onChange(itemKey, event.target.value as VideoOrientation)
        }
      >
        <FormControlLabel
          value="portrait"
          control={
            <Radio
              size="small"
              inputProps={{ id: stagedFieldId(itemKey, 'orientation') }}
            />
          }
          label={t('videos.staging.portrait')}
          disabled={isDisabled}
        />
        <FormControlLabel
          value="landscape"
          control={<Radio size="small" />}
          label={t('videos.staging.landscape')}
          disabled={isDisabled}
        />
      </RadioGroup>
      {!orientation && (
        <FormHelperText error>
          {t('videos.staging.orientationRequired')}
        </FormHelperText>
      )}
    </Field>
  );
};

export default OvVideoOrientationField;

const Field = styled.div`
  display: flex;
  flex-direction: column;
`;

const Question = styled.span`
  font-size: ${Variables.fontSizes.SMALL};
  color: ${Colours.OV_CHARCOAL};
  overflow-wrap: anywhere;
`;
